<template>
    <div>
        <Mainlayout></Mainlayout>
        <CCol sm="12" class="bg-white">
            <br /><br /><br />
            <CCol sm="12" style="width: 80%; background-size: cover; margin: auto; color: #fff">
                <br /><br /><br />
                <CRow>
                    <CCol sm="8" style="background-size: cover; margin: auto; color: #fff">
                        <CCard class="bg-white border-grey-card b-20">
                            <CRow class="p-20 m-3" style="display: block;justify-content: center;">
                                <div class="text-center mt-5">
                                    <img style="max-width: 300px" src="../assets/img/successPopup.png" class="m-0" />
                                    <h4 class="custom-16px-400">Payment Success</h4>
                                    <h3 class="custom-48px-500">
                                        $ {{ details.AmountUsd }}
                                    </h3>
                                    <CCard class="b-20">
                                        <CRow class="p-3">
                                            <CCol sm="8">
                                                <h3 class="custom-18px-600 text-left">Payment Details</h3>
                                            </CCol>
                                            <CCol sm="4" class="text-right">
                                                <img src="../assets/img/arrow-top.png" style="width:20px" />
    
                                            </CCol>
    
                                            <CCol sm="8" class="mt-2">
                                                <h3 class="custom-13px-500 text-left">Ref Number</h3>
                                            </CCol>
                                            <CCol sm="4" class="text-right">
                                                <h3 class="custom-13px-500 text-right">{{ refNo }}</h3>
                                            </CCol>
    
                                            <CCol sm="8" class="mt-2">
                                                <h3 class="custom-13px-500 text-left">Payment Status</h3>
                                            </CCol>
                                            <CCol sm="4" class="text-right">
    
                                                <h3 class="custom-13px-500 text-right"><img style="max-width:20px" src="../assets/img/tick-circle.png" />Success</h3>
                                            </CCol>
    
                                            <CCol sm="8" class="mt-2">
                                                <h3 class="custom-13px-500 text-left">Payment Time</h3>
                                            </CCol>
                                            <CCol sm="4" class="text-right">
                                                <h3 class="custom-13px-500 text-right">{{ details.CreatedDate | moment("DD-MMM-YYYY hh:mm:ss") }}</h3>
                                            </CCol>
    
                                            <CCol sm="12">
                                                <hr class="dashed-line">
                                            </CCol>
    
                                            <CCol sm="8" class="mt-2">
                                                <h3 class="custom-13px-500 text-left">Total Payment</h3>
                                            </CCol>
                                            <CCol sm="4" class="text-right">
                                                <h3 class="custom-24px-600 text-right font-color-171717">
                                        $ {{ details.AmountUsd }}</h3>
                                            </CCol>
                                            <CCol sm="6"> <label class="custom-border-purple-white p-2 mr-2 font-color-928AFD text-center mt-5 mb-5" style="width:100%" @click="printPage"><img style="width:20px" src="../assets/img/Download.png" />Download</label></CCol>
                                            <CCol sm="6"> <label class="custom-border-purple p-2 mr-2 text-white text-center mt-5 mb-5" style="width:100%" @click="OpenHomePage()">OK</label></CCol>
                                        </CRow>
                                    </CCard>
                                </div>
                            </CRow>
                            <br /><br />
                        </CCard>
                    </CCol>
    
                </CRow>
            </CCol>
    
    
    
    
        </CCol>
        <Footerlayout></Footerlayout>
    </div>
</template>
  
<script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(require("vue-moment"));
Vue.use(require("moment"));
var moment = require("moment");

Vue.use(Carousel3d);

import backgroundUrl from "../assets/img/bgPurpleYellow.png";
import backgroundUrl1 from "../assets/img/BgPeople.png";
import backgroundGenie from "../assets/img/bggenie.png";
import backgroundUrNoArrow from "../assets/img/bgline.png";

import Mainlayout from "../containers/AllHeader.vue";
import Footerlayout from "../containers/TheFooter.vue";
import ToggleCard from "../components/Toggle.vue";

export default {
    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        Footerlayout,
        ToggleCard,
    },

    data() {
        return {
            backgroundUrl,
            backgroundUrl1,
            backgroundUrNoArrow,
            backgroundGenie,
            isActive: false,

            packages: [],
            details: {},
            refNo: this.$route.query.refNo,
            amount: 0,
        };
    },
    async mounted() {

       this.GetDetailPackage()
        this.GetSuccessPayment();

    },
    methods: {

       
        async GetDetailPackage() {
            try {
                const response = await this.$API.get(this.$GetPackageCandidateById + "?id=" + this.$route.query.packageId);
                if (response.status === 200) {
                    this.packages = response.data;
                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },
        async GetSuccessPayment() {
            try {
                const response = await this.$API.get(this.$GetSuccessPaymentSubscription + "?userId=" + this.$route.query.userId);
                if (response.status === 200) {
                    this.details = response.data;
                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },
        ConvertExchangeRate() {
            this.targetCurrency = this.user.currency;
            this.priceInUSD = this.$route.query.amount;

            // Fetch exchange rate for USD to targetCurrency
            fetch(`https://api.exchangerate-api.com/v4/latest/USD`)
                .then(response => response.json())
                .then(data => {
                    const exchangeRate = data.rates[this.targetCurrency];
                    if (exchangeRate) {
                        this.amount = (this.priceInUSD * exchangeRate).toFixed(2);
                    } else {
                        alert(`Failed to fetch exchange rate for ${this.targetCurrency}`);
                    }
                })
                .catch(error => {
                    console.error('Error fetching exchange rate:', error);
                });
        },
        printPage() {
            window.print();
        },
        OpenHomePage()
        {
            this.$router.push("/");
        }



    },
};
</script>
  
<style scoped>
@import url('https://fonts.cdnfonts.com/css/general-sans');
body {
    top: 0 !important;
    font-family: 'General Sans', sans-serif;
}

.watermark {
    position: absolute;
    top: 24%;
    left: 25%;
    transform: rotate(-40deg);
    font-size: 80px;
    color: rgba(0, 0, 0, 0.1);
    /* Adjust opacity as needed */
    pointer-events: none;
    /* Make sure the watermark doesn't interfere with other elements */
    z-index: 1;
}
</style>
  